<template>
	<section class="container">
		<slot></slot>
	</section>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
	name: "ResponsiveContainer",
});
</script>
